import { render, staticRenderFns } from "./InternalReferences.vue?vue&type=template&id=7afe9f8c"
import script from "./InternalReferences.vue?vue&type=script&lang=js"
export * from "./InternalReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports